import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';

import { SponsorBannerDto } from '../models/dto/sponsor-banner-dto';

export class SponsorBannerApi {
    constructor(protected baseUrl: string) {}

    public getSponsorBanners = (): Promise<ApiResult<SponsorBannerDto[]>> => {
        return safeRequest(
            () =>
                request.get<PaginatedResponse<SponsorBannerDto>>(`${this.baseUrl}/sponsor-banners`, {
                    params: new URLSearchParams({ limit: '1000' }),
                }),
            response => response.data.items
        );
    };
}
